// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__e_mE7","left":"InfoRow_left__1QA80"};